<template>
  <div class="space-y-12 py-24 md:space-y-20">
    <div v-for="n in 2" :key="n" class="px-24">
      <JSkeleton
        :options="{
          borderRadius: 16,
          type: 'rectangle',
          width: '100%',
          height: isMobile ? '420px' : '320px',
        }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { JSkeleton } from '@journey/ui-kit'
import { useDevicePlatform } from '@/modules/Core/composables'

const { isMobile } = useDevicePlatform()
</script>
